import { cn, convertToSlug } from '@sohanemon/utils';
import { localizeDigits } from '@sohanscript/lib/utils/format';
import { Safari } from '@sohanscript/ui/mock/safari';
import type * as React from 'react';
import type { Experience } from '#/lib/hooks/sohanemon.tsx';

type MobileExperienceCardProps = React.ComponentProps<'div'> & {
	item: Experience;
	index: number;
};
export function MobileExperienceCard({
	className,
	item,
	index,
	...props
}: MobileExperienceCardProps) {
	return (
		<Safari mini url={`file://sohan/exp/${convertToSlug(item.company)}`}>
			<main className={cn('space-y-5 p-4', className)} {...props}>
				<p className="font-mono text-primary text-xs uppercase tracking-[0.28em]">
					{localizeDigits(item.period)}
				</p>
				<div>
					<h3 className="font-black text-3xl text-foreground uppercase leading-none tracking-[-0.05em]">
						{item.company}
					</h3>
					<p className="mt-3 font-semibold text-lg text-primary">{item.role}</p>
					<p className="mt-1 font-mono text-2xs text-muted-foreground uppercase tracking-[0.22em]">
						{item.location}
					</p>
				</div>
				<p className="text-muted-foreground text-sm leading-7">
					{item.summary}
				</p>
			</main>
		</Safari>
	);
}
